module.exports = __webpack_public_path__ + "img/fas-logo.22300976.png";